import { Nothing } from 'purify-ts/Maybe';
export const buildStateMachine = (stateTransitions) => (state, action) => {
    const maybeNextState = stateTransitions.reduce((maybeNextState, stateTransition) => maybeNextState.alt(stateTransition(state, action)), Nothing);
    return maybeNextState.caseOf({
        Just: (nextState) => nextState,
        Nothing: () => state,
    });
};
